export default __webpack_public_path__ + "static/media/trade1.0b10a6b9.png";